/**
 * Convert an object to a query string, supports converting nested arrays
 * @TODO impliment support for nested objects as well
 * @TODO consider URI Encoding
 * @param  {object} obj to convert to query string
 * @return {string}     query string
 */
export default function getStringFromObject(obj, prefix = false) {
  return Object.keys(obj)
    .map((key) => {
      const pre = prefix ? `${prefix}-${encodeURIComponent(key)}-` : key;
      const val = Array.isArray(obj[key]) ?
        obj[key].map((item) => encodeURIComponent(item)).join('~') :
        encodeURIComponent(obj[key]);
      return 'object' === typeof obj[key] && !Array.isArray(obj[key]) ?
        getStringFromObject(obj[key], pre) :
        `${pre}=${val}`;
    })
    .join('&');
}



// WEBPACK FOOTER //
// ./app/utils/query/getStringFromObject.js